"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.anaemiaTypeMessages = exports.renalAnaemiaHematologyTypeMessages = exports.hasDiseaseMessages = exports.AnaemiaType = exports.RenalAnaemiaHematologyType = exports.HasDisease = void 0;
const schema_1 = require("../../../../schema");
var HasDisease;
(function (HasDisease) {
    HasDisease["HAS_RENAL_ANAEMIA_HEPATOLOGY_DISEASE"] = "has_renal_anaemia_hepatology_disease";
    HasDisease["NO_UNKNOWN_RENAL_ANAEMIA_HEPATOLOGY_DISEASE"] = "no_unknown_renal_anaemia_hepatology_disease";
})(HasDisease || (exports.HasDisease = HasDisease = {}));
var RenalAnaemiaHematologyType;
(function (RenalAnaemiaHematologyType) {
    RenalAnaemiaHematologyType["ANAEMIA"] = "anaemia";
    RenalAnaemiaHematologyType["LEUKOPAENIA"] = "leukopaenia";
    RenalAnaemiaHematologyType["THROMBOPAENIA"] = "thrombopaenia";
})(RenalAnaemiaHematologyType || (exports.RenalAnaemiaHematologyType = RenalAnaemiaHematologyType = {}));
var AnaemiaType;
(function (AnaemiaType) {
    AnaemiaType["MICROCYTER_ANAEMIA"] = "microcyter_anaemia";
    AnaemiaType["NORMOCYTER_ANAEMIA"] = "normocyter_anaemia";
    AnaemiaType["MACROCYTER_ANAEMIA"] = "macrocyter_anaemia";
    AnaemiaType["NO_ANAEMIA"] = "no_anaemia";
})(AnaemiaType || (exports.AnaemiaType = AnaemiaType = {}));
exports.hasDiseaseMessages = {
    [HasDisease.HAS_RENAL_ANAEMIA_HEPATOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.renalAnaemiaHematology.hasDisease.HAS_RENAL_ANAEMIA_HEPATOLOGY_DISEASE",
        defaultMessage: "Diagnosztizált renális anaemia - hematológia"
    },
    [HasDisease.NO_UNKNOWN_RENAL_ANAEMIA_HEPATOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.renalAnaemiaHematology.hasDisease.NO_UNKNOWN_RENAL_ANAEMIA_HEPATOLOGY_DISEASE",
        defaultMessage: "Nincs vagy nem ismert"
    }
};
exports.renalAnaemiaHematologyTypeMessages = {
    [RenalAnaemiaHematologyType.ANAEMIA]: {
        id: "ktx.transplantationScreening.medicalHistory.renalAnaemiaHematology.renalAnaemiaHematologyType.ANAEMIA",
        defaultMessage: "Anaemia"
    },
    [RenalAnaemiaHematologyType.LEUKOPAENIA]: {
        id: "ktx.transplantationScreening.medicalHistory.renalAnaemiaHematology.renalAnaemiaHematologyType.LEUKOPAENIA",
        defaultMessage: "Leukopaenia"
    },
    [RenalAnaemiaHematologyType.THROMBOPAENIA]: {
        id: "ktx.transplantationScreening.medicalHistory.renalAnaemiaHematology.renalAnaemiaHematologyType.THROMBOPAENIA",
        defaultMessage: "Thrombopaenia"
    }
};
exports.anaemiaTypeMessages = {
    [AnaemiaType.MICROCYTER_ANAEMIA]: {
        id: "ktx.transplantationScreening.medicalHistory.renalAnaemiaHematology.anaemiaType.MICROCYTER_ANAEMIA",
        defaultMessage: "Microcyter anaemia"
    },
    [AnaemiaType.NORMOCYTER_ANAEMIA]: {
        id: "ktx.transplantationScreening.medicalHistory.renalAnaemiaHematology.anaemiaType.NORMOCYTER_ANAEMIA",
        defaultMessage: "Normocyter anaemia"
    },
    [AnaemiaType.MACROCYTER_ANAEMIA]: {
        id: "ktx.transplantationScreening.medicalHistory.renalAnaemiaHematology.anaemiaType.MACROCYTER_ANAEMIA",
        defaultMessage: "Macrocyter anaemia"
    },
    [AnaemiaType.NO_ANAEMIA]: {
        id: "ktx.transplantationScreening.medicalHistory.renalAnaemiaHematology.anaemiaType.NO_ANAEMIA",
        defaultMessage: "Ismeretlen Anaemia"
    }
};
const hasDisease = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HasDisease.HAS_RENAL_ANAEMIA_HEPATOLOGY_DISEASE).interpretation({
        vocab: "ktx",
        code: "has_renal_anaemia_hepatology_disease"
    }),
    schema_1.Schema.singleChoiceItem(HasDisease.NO_UNKNOWN_RENAL_ANAEMIA_HEPATOLOGY_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "no_unknown_renal_anaemia_hepatology_disease"
    })
        .tag({ vocab: "ktx", code: "renal_anaemia_hematology_type" })
]).interpretation({
    vocab: "ktx",
    code: "has_renal_anaemia_hepatology_disease_choice"
});
const renalAnaemiaHematologyType = schema_1.Schema.multiChoice([
    schema_1.Schema.multiChoiceItem(RenalAnaemiaHematologyType.ANAEMIA).interpretation({
        vocab: "ktx",
        code: "anaemia"
    }),
    schema_1.Schema.multiChoiceItem(RenalAnaemiaHematologyType.LEUKOPAENIA)
        .interpretation({ vocab: "ktx", code: "leukopaenia" })
        .tag({ vocab: "ktx", code: "renal_anaemia_hematology_type" }),
    schema_1.Schema.multiChoiceItem(RenalAnaemiaHematologyType.THROMBOPAENIA)
        .interpretation({ vocab: "ktx", code: "thrombopaenia" })
        .tag({ vocab: "ktx", code: "renal_anaemia_hematology_type" })
]);
const anaemiaType = schema_1.Schema.ifThen(schema_1.Schema.expression(`Array.isArray({../renalAnaemiaHematologyType}) && ({../renalAnaemiaHematologyType}).includes("anaemia")`), schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AnaemiaType.MICROCYTER_ANAEMIA)
        .interpretation({ vocab: "ktx", code: "microcyter_anaemia" })
        .tag({ vocab: "ktx", code: "anaemia_type" })
        .tag({ vocab: "ktx", code: "renal_anaemia_hematology_type" }),
    schema_1.Schema.singleChoiceItem(AnaemiaType.NORMOCYTER_ANAEMIA)
        .interpretation({ vocab: "ktx", code: "normocyter_anaemia" })
        .tag({ vocab: "ktx", code: "anaemia_type" })
        .tag({ vocab: "ktx", code: "renal_anaemia_hematology_type" }),
    schema_1.Schema.singleChoiceItem(AnaemiaType.MACROCYTER_ANAEMIA)
        .interpretation({ vocab: "ktx", code: "macrocyter_anaemia" })
        .tag({ vocab: "ktx", code: "anaemia_type" })
        .tag({ vocab: "ktx", code: "renal_anaemia_hematology_type" }),
    schema_1.Schema.singleChoiceItem(AnaemiaType.NO_ANAEMIA)
        .interpretation({ vocab: "ktx", code: "no_anaemia" })
        .tag({ vocab: "ktx", code: "anaemia_type" })
        .tag({ vocab: "ktx", code: "renal_anaemia_hematology_type" })
]));
const diseases = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../hasDisease} === "has_renal_anaemia_hepatology_disease"`), schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ renalAnaemiaHematologyType, anaemiaType }));
const comment = schema_1.Schema.string().optional().maxLength(10000);
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ hasDisease, diseases, comment })
    .interpretation({
    vocab: "ktx",
    code: "renal_anaemia_hematology_statement"
});
